var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"el-column"},[_c('div',{staticClass:"el-bounds _narrow"},[_c('div',{staticClass:"emd-text _align_center"},[(_vm.code === 404)?_c('error-404'):_c('error-500',{on:{"ctaClicked":_vm.refreshPage}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }